<template>
  <div class="template chatTheme">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="addPop">{{$t('im.chatTheme.createTheme')}}</el-button>
        <el-button @click="deleteAllPop">{{$t('im.bt.delete')}}</el-button>
      </el-form-item>
    </el-form>
    <el-table border :data="tableList" tooltip-effect="dark" style="width: 100%" @selection-change="selectionChatData">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column :prop="itemTabNav.id" :label="itemTabNav.name" v-for="itemTabNav in tableNav"></el-table-column>
      <el-table-column :label="$t('im.bt.operator')">
        <template slot-scope="scope">
          <el-button size="mini" @click="editChatPop(scope.row)">{{$t('im.bt.update')}}</el-button>
          <el-button size="mini" type="danger" @click="deletePop(scope.row)">{{$t('im.bt.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flexEnd" v-if="totalNum>0">
      <el-pagination
        background
        @size-change="pageSizeChange"
        @current-change="currentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination>
    </div>
    <el-dialog :title="oftenTitle" :visible.sync="isToOftenPop">
      <el-form class="div_form" label-width="80px">
        <el-form-item :label="$t('im.chatTheme.theme')">
          <el-input v-model="titleTxt"></el-input>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary" @click="submitSave">{{$t('im.bt.definite')}}</el-button>
        <el-button @click="isToOftenPop=false">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  require('@/styles/IM/template.css')
  import apiDeployManagement from '@/api/im/deployManagement'
  import Util from '@/utils/IM/tradeDataUtil'
  import { localRead } from '@/utils/tools'
  export default {
    name: 'chatTheme',
    data(){
      return{
        util: Util,
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        resourceType: '',//0：新增，1：编辑
        oftenTitle: window.$t('im.chatTheme.createTheme'),//弹窗名称
        tableList: [],  //当前资源列表
        tableNav: [{ name: window.$t('im.chatTheme.theme'), id: 'dictValue' },],  //当前资源列表头部
        totalNum: 0,  //当前资源条数
        currentPage:1,  //当前页数
        pageSize:10, //当前页条数数
        chatID:"",//当前数据ID
        isToOftenPop:false, //弹窗是否显示
        titleTxt:"",  //主题
        multipleSelection:[],  //选择条数集合
      }
    },
    methods:{
      selectionChatData(val) {
        let data = []
        if (val.length > 0) {
          for (const i in val) {
            data.push(val[i].id)
          }
          this.multipleSelection = data
        } else {
          this.multipleSelection = []
        }
      },
      /*新建主题弹窗*/
      addPop() {
        this.isToOftenPop = true
        this.resourceType = 0
        this.oftenTitle = window.$t('im.chatTheme.createTheme')
        this.titleTxt = ''
      },
      /*修改当前*/
      editChatPop(data) {
        this.isToOftenPop = true
        this.resourceType = 1
        this.oftenTitle = $t('im.chatTheme.updateTheme')
        this.titleTxt = data.dictValue
        this.chatID = data.id
      },
      /*获取数据*/
      getChatList(data){
        apiDeployManagement.queryConAccessDictListPage(data).then(res=>{
          if (res.code == 0){
            if (res.result.list) {
              this.tableList = res.result.list
              this.totalNum = res.result.total
            } else {
              this.tableList = []
              this.totalNum = 0
            }
          }
        })
      },
      /*初始化数据*/
      initChatList(){
        let data = {
          companyId: this.userInfo.companyId,
          dictType: 0,
          pageNum: this.currentPage
        };
        this.getChatList(data)
      },
      /*新增数据*/
      addChatData(){
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          dictType: 0,
          dictValue: this.titleTxt,
        }
        apiDeployManagement.addConAccessDict(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initChatList()
          }
        })
      },
      /*修改数据*/
      editChatData() {
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          dictType: 0,
          dictValue: this.titleTxt,
          id: this.chatID
        }
        apiDeployManagement.updateConAccessDict(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initChatList()
          }
        })
      },
      /*删除弹窗*/
      deletePop(row) {
        this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
          confirmButtonText: window.$t('im.bt.definite'),
          cancelButtonText: window.$t('im.bt.cancel'),
          type: 'warning',
          center: true
        }).then(() => {
          this.deleteChatData(row)
        }).catch(() => {
          this.$message.info(window.$t('im.common.cancelDel'))
        })
      },
      /*删除当前*/
      deleteChatData(row) {
        let data = { id: row.id }
        apiDeployManagement.deleteConAccessDict(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.delSuc'))
            this.initChatList()
          } else {
            this.$message.error(window.$t('im.common.delFail'));
          }
        })
      },
      /*删除所有弹窗*/
      deleteAllPop() {
        if (this.multipleSelection.length > 0){
          this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
            confirmButtonText: window.$t('im.bt.definite'),
            cancelButtonText: window.$t('im.bt.cancel'),
            type: 'warning',
            center: true
          }).then(() => {
            this.deleteAllChatData()
          }).catch(() => {
            this.$message.info(window.$t('im.common.cancelDel'))
          })
        }

      },
      /*删除所有*/
      deleteAllChatData() {
        let data = { ids: this.multipleSelection.join(',') }
        apiDeployManagement.deleteBatchConAccessDict(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.delSuc'))
            this.initChatList()
          } else {
            this.$message.error(window.$t('im.common.delFail'));
          }
        })
      },
      /*切换分页条数*/
      pageSizeChange(val) {
        this.pageSize = val
        let data = {
          companyId: this.userInfo.companyId,
          dictType: 0,
          pageNum: this.currentPage,
          pageSize: val
        }
        this.getChatList(data)
      },
      /*切换当前页*/
      currentChange(val) {
        this.currentPage = val
        let data = {
          companyId: this.userInfo.companyId,
          dictType: 0,
          pageNum: val,
          pageSize: this.pageSize
        }
        this.getChatList(data)
      },
      /*保存数据*/
      submitSave(){
        if (Util.isNotEmpty(this.titleTxt.replace(/\s/g, ''))) {
          if (this.resourceType == 0) {
            this.addChatData()
          } else if (this.resourceType == 1) this.editChatData()
        }
      }

    },
    mounted() {
      this.initChatList()
    }
  }
</script>

<style>
  .chatTheme .div_form .el-select{width: 100%}
</style>
